export default function isPnoFormat(value, tld) {
  const datePattern = tld === 'se' ? '(\\d{6}|\\d{8})' : '(\\d{6})';
  const delimiterPattern = tld !== 'no' ? '[-]?' : '';
  const sequenceNumberPattern = tld === 'no' ? '\\d{5}' : '\\d{4}';
  const regExp = new RegExp(`^${datePattern}${delimiterPattern}${sequenceNumberPattern}$`);

  return value.match(regExp) !== null;
}
